import { render, staticRenderFns } from "./OtherShippersHead.vue?vue&type=template&id=10ed2fbc&scoped=true"
import script from "./OtherShippersHead.vue?vue&type=script&lang=js"
export * from "./OtherShippersHead.vue?vue&type=script&lang=js"
import style0 from "./OtherShippersHead.vue?vue&type=style&index=0&id=10ed2fbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ed2fbc",
  null
  
)

export default component.exports